import { Info } from 'lucide-react';
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { EventFieldType } from 'types/EventField';
import {
  API_REQUEST_STATUS_FAIL,
  API_REQUEST_STATUS_PENDING,
  API_REQUEST_STATUS_SUCCESS,
} from 'utils/static/constants';
import LoadingSpinner from '../Common/LoadingSpinner';
import EventFieldSwitcher from '../CustomerForm/EventFieldSwitcher';
import { OveitIcon } from '../OveitIcon';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

interface RegistrationFormProps {
  ticketId: number;
  ticketIndex: number;
  fields: EventFieldType[];
  requestStatus: string;
  disabled: boolean;
}

const RegistrationForm: React.FC<RegistrationFormProps> = ({
  ticketId,
  ticketIndex,
  fields,
  requestStatus,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <Suspense fallback={<LoadingSpinner />}>
        <div className="registration-forms">
          {fields.map(field => (
            <EventFieldSwitcher
              key={field.id}
              inputName={`${ticketId}-${field.id}-${ticketIndex}`}
              field={{
                ...field,
                label: field.label,
              }}
              disabled={disabled}
            />
          ))}
          <div
            className={`flex justify-end items-center gap-[8px] mt-auto ${
              fields.length % 2 === 0 ? 'sm:col-span-2' : ''
            }`}
          >
            <div>
              {requestStatus === API_REQUEST_STATUS_FAIL && (
                <p className="standard-input-error">
                  {t('apiErrors.anErrorOccured')}
                </p>
              )}
            </div>
            {disabled && requestStatus !== API_REQUEST_STATUS_PENDING ? (
              <Popover>
                <PopoverTrigger asChild>
                  <Button variant="ghost" size="icon" type="button">
                    <Info size={16} />
                  </Button>
                </PopoverTrigger>
                <PopoverContent
                  side="top"
                  className="text-center p3-medium p-2"
                >
                  {t('registrationFormsPage.saveButtonDisabledTooltip')}
                </PopoverContent>
              </Popover>
            ) : null}
            <Button
              type="submit"
              disabled={
                disabled || requestStatus === API_REQUEST_STATUS_PENDING
              }
            >
              {requestStatus === API_REQUEST_STATUS_PENDING ? (
                <LoadingSpinner variant="small" color="primary" />
              ) : null}
              {t('common.save')}
            </Button>
          </div>
        </div>
      </Suspense>
    </div>
  );
};

export default RegistrationForm;
